export enum EAgroservicesTypes {
  WIDE = 'WIDE',
}
